export var HeadingAlignBaseline;
(function (HeadingAlignBaseline) {
    HeadingAlignBaseline["small"] = "small";
    HeadingAlignBaseline["large"] = "large";
})(HeadingAlignBaseline || (HeadingAlignBaseline = {}));
export var HeadingSize;
(function (HeadingSize) {
    HeadingSize[HeadingSize["_1"] = 1] = "_1";
    HeadingSize[HeadingSize["_2"] = 2] = "_2";
    HeadingSize[HeadingSize["_3"] = 3] = "_3";
    HeadingSize[HeadingSize["_4"] = 4] = "_4";
    HeadingSize[HeadingSize["_5"] = 5] = "_5";
    HeadingSize[HeadingSize["_6"] = 6] = "_6";
    HeadingSize[HeadingSize["_7"] = 7] = "_7";
})(HeadingSize || (HeadingSize = {}));
export var HeadingTag;
(function (HeadingTag) {
    HeadingTag["h1"] = "h1";
    HeadingTag["h2"] = "h2";
    HeadingTag["h3"] = "h3";
    HeadingTag["h4"] = "h4";
    HeadingTag["h5"] = "h5";
    HeadingTag["h6"] = "h6";
    HeadingTag["p"] = "p";
})(HeadingTag || (HeadingTag = {}));
